export default{
    httpOptions: [
        {
            label: 'http://',
            value: 'http://'
        },
        {
            label: 'https://',
            value: 'https://'
        }
    ],
    // 中国大陆证件类型
    idTypeOptions:[
        {
            label:'华侨(持有国外永久居留证,如绿卡,枫叶卡)',
            value:'华侨(持有国外永久居留证,如绿卡,枫叶卡)'
        },
        {
            label:'持有一年以上境外有效工作签证的中国护照',
            value:'持有一年以上境外有效工作签证的中国护照'
        },
        {
            label:'持对外劳动服务公司签发的工作证',
            value:'持对外劳动服务公司签发的工作证'
        }
    ],
    // 非中国大陆 港澳台 证件类型
    idTypeOptionsEN:[
        // {
        //     label:'海外护照',
        //     value:'海外护照'
        // },
        // {
        //     label:'港澳身份证',
        //     value:'港澳身份证'
        // },
        // {
        //     label:'台胞证',
        //     value:'台胞证'
        // }
        {
            label:'护照',
            value:'护照'
        }
    ],
    // 香港证件类型
    idTypeOptionsHK:[
        {
            label:'港澳居民来往内地通行证',
            value:'港澳居民来往内地通行证'
        },
        {
            label:'香港永久性居民身份证',
            value:'香港永久性居民身份证'
        },
        {
            label:'护照',
            value:'护照'
        }
    ],
    // 澳门证件类型
    idTypeOptionsMO:[
        {
            label:'港澳居民来往内地通行证',
            value:'港澳居民来往内地通行证'
        },
        {
            label:'澳门居民身份证',
            value:'澳门居民身份证'
        },
        {
            label:'护照',
            value:'护照'
        }
    ],
    // 台湾证件类型
    idTypeOptionsTWN:[
        {
            label:'台湾居民来往大陆通行证',
            value:'台湾居民来往大陆通行证'
        },
        {
            label:'台湾身份证',
            value:'台湾身份证'
        },
        {
            label:'护照',
            value:'护照'
        }
    ],
    idTypeOptionsOnlyCN:[//只能是中文
        {
            label:'华侨(持有国外永久居留证,如绿卡,枫叶卡)',
            value:'华侨(持有国外永久居留证,如绿卡,枫叶卡)'
        },
        {
            label:'持有一年以上境外有效工作签证的中国护照',
            value:'持有一年以上境外有效工作签证的中国护照'
        },
        {
            label:'持对外劳动服务公司签发的工作证',
            value:'持对外劳动服务公司签发的工作证'
        }
    ],
    idTypeOptionsOnlyEN:[//只能是英文
        {
            label:'Overseas passport',
            value:'Overseas passport'
        },
        {
            label:'HK or Macao I.D. Card',
            value:'HK or Macao I.D. Card'
        },
        {
            label:'Taiwan Compatriot Travel Certificate',
            value:'Taiwan Compatriot Travel Certificate'
        }
    ],
    socialMediaOptions:[
        {
            label:'facebook',
            value:'facebook'
        },
        {
            label:'linkedin',
            value:'linkedin'
        },
        {
            label:'instagram',
            value:'instagram'
        },
        {
            label:'pinterest',
            value:'pinterest'
        },
        {
            label:'twitter',
            value:'twitter'
        },
        {
            label:'wechat',
            value:'wechat'
        },
        {
            label:'QQ',
            value:'QQ'
        },
        {
            label:'YouTube',
            value:'YouTube'
        }
    ],
    liveOption:[
        {
            label:'默认',
            value:0
        },
        {
            label:'最新直播',
            value:1
        },
        {
            label:'人气值从高到低',
            value:2
        },
        {
            label:'开播时间升序',
            value:3
        }
    ]
}